const initialState = () => ({
  partnerOrderTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  loadingOrder: true,
  partnerOrderTableSearch: '',
  partnerOrders: [],
  selectedCorp: 0,
});

export default initialState;
